import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Component } from 'react';
import { Button } from '../components/button';
import { CopyButton } from '../components/copy-button';
import { EmptyScreen } from '../components/empty-screen/index';
export class HooksForm extends Component {
    constructor(props) {
        super(props);
        this.tokenField = null;
        this.setTokenFieldRef = (element) => {
            this.tokenField = element;
        };
        this.callbackField = null;
        this.setCallbackFieldRef = (element) => {
            this.callbackField = element;
        };
        this.copyCallback = this.copyCallback.bind(this);
        this.copyToken = this.copyToken.bind(this);
    }
    componentDidMount() {
        this.props.getHooks({ appId: this.props.appId });
    }
    copyCallback() {
        this.callbackField.select();
        document.execCommand('copy');
        this.callbackField.blur();
    }
    copyToken() {
        this.tokenField.select();
        document.execCommand('copy');
        this.tokenField.blur();
    }
    render() {
        return (_jsxs("div", { children: [_jsxs("div", Object.assign({ className: "messenger-form", onSubmit: this.handleSubmit }, { children: [_jsx("h2", Object.assign({ className: "messenger-form__headline" }, { children: "Setup Messenger & Webhooks" })), _jsxs("div", Object.assign({ className: "messenger-form__field messenger-form__field--withcopy" }, { children: [_jsx("label", Object.assign({ htmlFor: "messenger-callback-url", className: "messenger-form__field__label" }, { children: "Callback URL" })), _jsx("input", { id: "messenger-app-url", type: "text", className: "messenger-form__field__input", ref: this.setCallbackFieldRef, value: this.props.callback }), _jsx(CopyButton, { className: "messenger-form__field__copy", onClick: this.copyCallback })] })), _jsxs("div", Object.assign({ className: "messenger-form__field messenger-form__field--withcopy" }, { children: [_jsx("label", Object.assign({ htmlFor: "messenger-callback-url", className: "messenger-form__field__label" }, { children: "Verification token" })), _jsx("input", { id: "messenger-app-token", type: "text", className: "messenger-form__field__input", ref: this.setTokenFieldRef, value: this.props.token }), _jsx(CopyButton, { className: "messenger-form__field__copy", onClick: this.copyToken })] })), _jsx("div", Object.assign({ className: "messenger-form__actions" }, { children: _jsx(Button, Object.assign({ className: "messenger-form__submit", onClick: this.props.onSuccess }, { children: "Continue" })) }))] })), _jsx(EmptyScreen, { headline: "Facebook Messenger setup steps", ingredients: {
                        '1. Setup Facebook Messenger': 'https://support.dixa.help/en/articles/133',
                        '2. Setup Messenger Webhooks': 'https://support.dixa.help/en/articles/134-setup-messenger-webhooks',
                        '3. Add Facebook page': 'https://support.dixa.help/en/articles/135-add-facebook-page',
                        '4. Submit for review and publish': 'https://support.dixa.help/en/articles/136-submission-for-review-and-make-the-app-public',
                    } })] }));
    }
}
